import { allWarehouseHeights } from '../constants';
import styles from './ShelfGrid.module.css';

interface Props {
    location: string;
}

export const ShelfGrid = ({ location }: Props) => {

    const shelfName = location.substring(0, 7);
    const shelf = allWarehouseHeights.find(shelf => shelf.shelf === shelfName);
    if (!shelf) return <></>;
    const grid = Array.from({ length: shelf.height }, () => Array(shelf.width).fill(0))

    const x = Number(location[8]) - 1;
    const y = shelf.height - Number(location[10]);

    return (
        <div className={styles.container} key={shelfName}>
            {/* <div className={styles.shelfName}>{shelfName}</div> */}
            {grid.map((row, rowIndex) => (
                <div className={styles.row} key={rowIndex}>
                    {row.map((status, colIndex) => {
                        const isTarget = rowIndex === y && colIndex === x;
                        return (
                            <div className={`${styles.box} ${isTarget && styles.green}`} key={colIndex}></div>
                        );
                    })}
                </div>
            ))}
        </div>
    )
}